import { useAemConfig } from '@as-react/common-components';
import { UserVisibility } from '@as-react/common-types';
import { getHomepageUrl } from '@as-react/common-utils';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useFeatureToggle } from '../hooks/useFeatureToggle';
import { useOAuth } from '../hooks/useOAuth';
import { makeGetSessionState } from '../redux/session/selectors/SessionSelector';
import { isLoggedInUser, isLoggedInGuestWebReturns } from '../util/SessionUtil';
const GuestRedirectContainer = ({ visibility }) => {
    const { root } = useAemConfig();
    const userSession = useSelector(makeGetSessionState());
    const { isLoggedIn, redirectToLogin, loginState } = useOAuth({ cancelUrl: getHomepageUrl(root) });
    const isNewAuth = useFeatureToggle('use_new_auth_flow');
    useEffect(() => {
        var _a;
        if (loginState === 'PENDING') {
            return;
        }
        if ((isNewAuth && isLoggedIn) || (!isNewAuth && !((_a = userSession === null || userSession === void 0 ? void 0 : userSession.authorities) === null || _a === void 0 ? void 0 : _a.length)))
            return;
        if (isNewAuth && !isLoggedIn) {
            redirectToLogin();
            return;
        }
        switch (visibility) {
            case UserVisibility.AUTHORIZED:
                !isLoggedInUser(userSession) && redirectToLogin();
                break;
            case UserVisibility.AUTHORIZED_AND_SOFT_LOGGED_IN:
                !isLoggedInUser(userSession) && !isLoggedInGuestWebReturns(userSession) && redirectToLogin();
                break;
            default:
                break;
        }
    }, [userSession, isLoggedIn, isNewAuth, loginState]);
    return null;
};
export default GuestRedirectContainer;
